import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import ReactSelect from '../../components/ReactSelect';
import { buscarCep, extract } from '../../util/util';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import '../../css/financeiro-parcela-pagar.css';

const OPTS_SITUACAO = [
    { value: 'ativo', label: 'Ativo' },
    { value: 'inativo', label: 'Inativo' },
];

const OPTS_ESTADO_CIVIL = [
    { value: 'solteiro', label: 'Solteiro(a)' },
    { value: 'casado', label: 'Casado(a)' },
    { value: 'divorciado', label: 'Divorciado(a)' },
    { value: 'viuvo', label: 'Viúvo(a)' },
    { value: 'uniao_estavel', label: 'União Estável' },
];

const OPTS_FILHOS = [
    { value: 'sim', label: 'Sim' },
    { value: 'nao', label: 'Não' },
];

const OPTS_AUTORIZAANIVERSARIO = [
    { value: 'sim', label: 'Sim' },
    { value: 'nao', label: 'Não' },
];

const OPTS_INDICADORINSCRICAO = [
    { value: '1', label: 'Contribuinte' },
    { value: '2', label: 'Isento' },
    { value: '9', label: 'Não contribuinte' },
];

const OPTS_REGIMETRIBUTARIO = [
    { value: '1', label: 'MEI' },
    { value: '2', label: 'Simples Nacional' },
    { value: '3', label: 'Simples Nacional (Sublimite)' },
    { value: '4', label: 'Lucro Presumido' },
];

const OPTS_UF = [
    { value: "AC", label: "AC" }, { value: "AL", label: "AL" }, { value: "AP", label: "AP" },
    { value: "AM", label: "AM" }, { value: "BA", label: "BA" }, { value: "CE", label: "CE" },
    { value: "DF", label: "DF" }, { value: "ES", label: "ES" }, { value: "GO", label: "GO" },
    { value: "MA", label: "MA" }, { value: "MT", label: "MT" }, { value: "MS", label: "MS" },
    { value: "MG", label: "MG" }, { value: "PA", label: "PA" }, { value: "PB", label: "PB" },
    { value: "PR", label: "PR" }, { value: "PE", label: "PE" }, { value: "PI", label: "PI" },
    { value: "RJ", label: "RJ" }, { value: "RN", label: "RN" }, { value: "RS", label: "RS" },
    { value: "RO", label: "RO" }, { value: "RR", label: "RR" }, { value: "SC", label: "SC" },
    { value: "SP", label: "SP" }, { value: "SE", label: "SE" }, { value: "TO", label: "TO" },
];

const OPTS_NACIONALIDADE_EVENTO = [
    { value: 'nacional', label: 'Nacional' },
    { value: 'internacional', label: 'Internacional' },
];

export default function CadastroPessoa({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    const history = useHistory();
    const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const normalizarEmail = (valor) => (valor || '').trim().toLowerCase();

    const preencherCep = (cep, dadosAtuais) => {
        buscarCep(cep).then((resposta) => {
            if (!resposta.erro) {
                setDados({
                    ...dadosAtuais,
                    ...{
                        enderecobairro: resposta.bairro,
                        enderecocomplemento: resposta.complemento,
                        enderecologradouro: resposta.logradouro,
                        enderecopais: "30",
                        nomeEnderecopais: "Brasil",
                        enderecomunicipio: resposta.ibge,
                        nomeEnderecomunicipio: resposta.localidade
                    }
                });
            }
        });
    };

    const buscar = () => {
        setIsLoading(true);
        if (id) {
            api({
                method: "get",
                action: '/participante/' + id,
                token: token,
            }).then(response => { //extrai dados internos para o array principal
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: [
                        'cargo',
                        'enderecopais',
                        'aereomunicipioembarque',
                        'enderecomunicipio',
                        'banco',
                        'tipoparticipante'
                    ]
                });

                if (dadosRecebidos.cliente?.constructor !== Array)
                    dadosRecebidos.cliente = [];
                dadosRecebidos.cliente = dadosRecebidos.cliente
                    .filter(objeto => objeto.situacaoRegistro === 'ativo')
                    .map(function (objeto) {
                        return {
                            value: objeto.id,
                            label: objeto.nome
                        };
                    });

                if (dadosRecebidos.eventos?.constructor !== Array)
                    dadosRecebidos.eventos = [];
                dadosRecebidos.eventos = dadosRecebidos.eventos.map(function (objeto) {
                    return {
                        value: objeto.id,
                        label: objeto.nome
                    };
                });

                if (dadosRecebidos.unidadenegocio?.constructor !== Array)
                    dadosRecebidos.unidadenegocio = [];
                dadosRecebidos.unidadenegocio = dadosRecebidos.unidadenegocio.map(function (objeto) {
                    return {
                        value: objeto.id,
                        label: objeto.nome
                    };
                });

                if (dadosRecebidos.bu?.constructor !== Array)
                    dadosRecebidos.bu = [];
                dadosRecebidos.bu = dadosRecebidos.bu.map(function (objeto) {
                    return {
                        value: objeto.id,
                        label: objeto.nome
                    };
                });

                setDados(dadosRecebidos);
            }).catch(err => {
                //console.log(err)
            }).finally(() => { setIsLoading(false); });
        } else {
            setIsLoading(false);
        }
    };

    const validar = () => {
        var cargo = document.querySelector("#cargo");
        if (dados.cargo === undefined || dados.cargo === '') {
            toast.error('É necessário preencher o cargo');
            setTimeout(() => {
                cargo.focus();
            }, 500);
            return false;
        }

        if (!id) {
            const emailBase = normalizarEmail(dados.email || dados.emailsecundario);
            const emailContato = normalizarEmail(dados.emailsecundario || emailBase);

            if (!emailBase) {
                toast.error('É necessário informar um e-mail para o acesso.');
                setTimeout(() => {
                    document.querySelector("#email")?.focus();
                }, 500);
                return false;
            }

            if (!EMAIL_REGEX.test(emailBase)) {
                toast.error('O usuário deve ser um e-mail válido.');
                setTimeout(() => {
                    document.querySelector("#email")?.focus();
                }, 500);
                return false;
            }

            if (emailContato && !EMAIL_REGEX.test(emailContato)) {
                toast.error('O campo E-mail deve ter um formato válido.');
                setTimeout(() => {
                    document.querySelector("#emailsecundario")?.focus();
                }, 500);
                return false;
            }
        }

        return true;
    };

    const salvar = () => {

        if (isSubmitting) {
            return;
        }

        if (!validar()) {
            return false; //para codigo aqui
        }

        setIsSubmitting(true);

        const dadosParaSalvar = { ...dados };

        if (!id) {
            const emailBase = normalizarEmail(dadosParaSalvar.email || dadosParaSalvar.emailsecundario);
            dadosParaSalvar.email = emailBase;
            dadosParaSalvar.emailsecundario = emailBase;
        }

        if (dadosParaSalvar.cliente && Array.isArray(dadosParaSalvar.cliente)) {
            dadosParaSalvar.cliente = dadosParaSalvar.cliente.map(item => item.value).join(',');
        }

        if (dadosParaSalvar.eventos && Array.isArray(dadosParaSalvar.eventos)) {
            dadosParaSalvar.eventos = dadosParaSalvar.eventos.map(item => item.value).join(',');
        }

        if (dadosParaSalvar.unidadenegocio?.constructor === Array) {
            dadosParaSalvar.unidadenegocio = dadosParaSalvar.unidadenegocio.map(item => item.value).join(',');
        }

        if (dadosParaSalvar.bu?.constructor === Array) {
            dadosParaSalvar.bu = dadosParaSalvar.bu.map(item => item.value).join(',');
        }

        delete dadosParaSalvar.evento;

        if (id) {//update
            api({
                method: 'put',
                action: '/participante/' + id,
                token: token,
                data: dadosParaSalvar,
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/pessoa");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {//insert
            api({
                method: 'post',
                action: '/participante',
                token: token,
                data: { ...dadosParaSalvar, ...{ tipoCadastro: "pessoa" } }
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/pessoa");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    };

    useEffect(() => { //onload
        document.querySelector("#nome")?.focus(); //autofocus no nome
        buscar();
    },
        // eslint-disable-next-line
        []);

    const focarProximoControle = (e) => {
        if (e.key !== 'Enter' || e.target.tagName === 'TEXTAREA') {
            return;
        }

        const comboAberto = e.target.closest('[role="combobox"]');
        if (comboAberto?.getAttribute('aria-expanded') === 'true') {
            return;
        }

        e.preventDefault();

        const form = e.currentTarget;
        const controles = Array.from(form.querySelectorAll(
            'input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((elemento) => elemento.getClientRects().length > 0);

        const controleAtual = e.target.closest(
            'input:not([type="hidden"]), select, textarea, button, [tabindex]:not([tabindex="-1"])'
        );

        if (!controleAtual) {
            return;
        }

        const indiceAtual = controles.indexOf(controleAtual);
        if (indiceAtual === -1) {
            return;
        }

        const proximoControle = controles[indiceAtual + 1];
        if (proximoControle) {
            proximoControle.focus();
        }
    };

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Pessoa</h1></div>
                </div>

                <form noValidate onKeyDown={focarProximoControle} onSubmit={e => { salvar(); e.preventDefault(); }}>
                    <fieldset>

                        {/* Seção: Geral */}
                        <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                            <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                                <h2 className="fin-pp__cphead-title">Geral</h2>
                            </div>
                            <div className="fin-pp__filters">
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Situação</label>
                                    <ReactSelect
                                        value={{ value: dados.situacaoRegistro, label: dados.nomeSituacaoRegistro }}
                                        onChange={e => setDados({ ...dados, ...{ "situacaoRegistro": e.value, "nomeSituacaoRegistro": e.label } })}
                                        options={OPTS_SITUACAO}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Código</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="codigo"
                                        placeholder="Código"
                                        value={dados.codigo || ''}
                                        onChange={e => setDados({ ...dados, ...{ "codigo": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Cargo</label>
                                    <ReactSelect
                                        id="cargo"
                                        value={{ value: dados.cargo, label: dados.nomeCargo }}
                                        onChange={e => setDados({ ...dados, ...{ "cargo": e.value, "nomeCargo": e.label } })}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/rhCargo',
                                                token: token,
                                                params: { nome: input }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Nome Completo</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="nome"
                                        placeholder="Nome Completo"
                                        value={dados.nome || ''}
                                        onChange={e => setDados({ ...dados, ...{ "nome": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Razão Social</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="razaosocial"
                                        placeholder="Razão Social"
                                        value={dados.razaosocial || ''}
                                        onChange={e => setDados({ ...dados, ...{ "razaosocial": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Contato</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="contato"
                                        placeholder="Contato"
                                        value={dados.contato || ''}
                                        onChange={e => setDados({ ...dados, ...{ "contato": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Nome Social</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="nomesocial"
                                        placeholder="Nome Social"
                                        value={dados.nomesocial || ''}
                                        onChange={e => setDados({ ...dados, ...{ "nomesocial": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Telefone</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="telefone"
                                        placeholder="Telefones"
                                        value={dados.telefone || ''}
                                        onChange={e => setDados({ ...dados, ...{ "telefone": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Celular</label>
                                    <InputMask
                                        mask="(99) 99999-9999"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="celular"
                                        placeholder="Celular"
                                        value={dados.celular || ''}
                                        onChange={e => setDados({ ...dados, ...{ "celular": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Data de Nascimento</label>
                                    <input
                                        type="date"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="datanascimento"
                                        placeholder="Data de Nascimento"
                                        value={dados.datanascimento || ''}
                                        onChange={e => setDados({ ...dados, ...{ "datanascimento": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Estado Civil</label>
                                    <ReactSelect
                                        value={{ value: dados.estadocivil, label: dados.nomeEstadocivil }}
                                        onChange={e => setDados({ ...dados, ...{ "estadocivil": e.value, "nomeEstadocivil": e.label } })}
                                        options={OPTS_ESTADO_CIVIL}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Tem filhos?</label>
                                    <ReactSelect
                                        value={{ value: dados.temfilhos, label: dados.nomeTemfilhos }}
                                        onChange={e => setDados({ ...dados, ...{ "temfilhos": e.value, "nomeTemfilhos": e.label } })}
                                        options={OPTS_FILHOS}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Quantos?</label>
                                    <input
                                        type="number"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="quantidadefilhos"
                                        placeholder="Quantos?"
                                        value={dados.quantidadefilhos || ''}
                                        onChange={e => setDados({ ...dados, ...{ "quantidadefilhos": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Autoriza incluir aniversário no mural?</label>
                                    <ReactSelect
                                        value={{ value: dados.autorizaaniversariomural, label: dados.nomeautorizaaniversariomural }}
                                        onChange={e => setDados({ ...dados, ...{ "autorizaaniversariomural": e.value, "nomeautorizaaniversariomural": e.label } })}
                                        options={OPTS_AUTORIZAANIVERSARIO}
                                    />
                                </div>
                                <div className="fin-pp__field" style={{ flexBasis: '100%' }}>
                                    <label className="fin-pp__label">E-mail</label>
                                    <input
                                        type="email"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="emailsecundario"
                                        placeholder="E-mail"
                                        value={dados.emailsecundario || ''}
                                        onChange={e => setDados({ ...dados, ...{ "emailsecundario": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field" style={{ flexBasis: '100%' }}>
                                    <label className="fin-pp__label">Observações</label>
                                    <textarea
                                        className="fin-pp__input"
                                        style={{ height: 'auto', padding: '10px 14px', minHeight: '100px' }}
                                        id="observacao"
                                        placeholder="Observações"
                                        value={dados.observacao || ''}
                                        onChange={e => setDados({ ...dados, ...{ "observacao": e.target.value } })}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Seção: Endereço */}
                        <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                            <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                                <h2 className="fin-pp__cphead-title">Endereço</h2>
                            </div>
                            <div className="fin-pp__filters">
                                <div className="fin-pp__field" style={{ flexBasis: '60%' }}>
                                    <label className="fin-pp__label">Rua / Logradouro</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="enderecologradouro"
                                        placeholder="Rua / Logradouro"
                                        value={dados.enderecologradouro || ''}
                                        onChange={e => setDados({ ...dados, ...{ "enderecologradouro": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Número</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="endereconumero"
                                        placeholder="Número"
                                        value={dados.endereconumero || ''}
                                        onChange={e => setDados({ ...dados, ...{ "endereconumero": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field" style={{ flexBasis: '60%' }}>
                                    <label className="fin-pp__label">Complemento</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="enderecocomplemento"
                                        placeholder="Complemento"
                                        value={dados.enderecocomplemento || ''}
                                        onChange={e => setDados({ ...dados, ...{ "enderecocomplemento": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">CEP</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="enderecocep"
                                        placeholder="CEP"
                                        value={dados.enderecocep || ''}
                                        onChange={(e) => {
                                            dados.enderecocep = e.target.value;
                                            preencherCep(e.target.value, dados);
                                            setDados({ ...dados });
                                        }}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Bairro</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="enderecobairro"
                                        placeholder="Bairro"
                                        value={dados.enderecobairro || ''}
                                        onChange={e => setDados({ ...dados, ...{ "enderecobairro": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Estado</label>
                                    <ReactSelect
                                        id="enderecouf"
                                        value={{ value: dados.enderecouf, label: dados.enderecouf }}
                                        onChange={e => setDados({ ...dados, ...{ "enderecouf": e.value, "nomeUf": e.label } })}
                                        options={OPTS_UF}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Cidade</label>
                                    <ReactSelect
                                        key={"municipio-" + (dados.enderecouf ?? "todos")}
                                        value={{ value: dados.enderecomunicipio, label: dados.nomeEnderecomunicipio }}
                                        onChange={e => setDados({ ...dados, ...{ "enderecomunicipio": e.value, "nomeEnderecomunicipio": e.label } })}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/municipio',
                                                token: token,
                                                params: {
                                                    nome: input,
                                                    uf: dados.enderecouf ?? null
                                                }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + "-" + registro.uf }));
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">País</label>
                                    <ReactSelect
                                        value={{ value: dados.enderecopais, label: dados.nomeEnderecopais }}
                                        onChange={e => setDados({ ...dados, ...{ "enderecopais": e.value, "nomeEnderecopais": e.label } })}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/pais',
                                                token: token,
                                                params: { nome: input }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Seção: Fiscal */}
                        <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                            <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                                <h2 className="fin-pp__cphead-title">Fiscal</h2>
                            </div>
                            <div className="fin-pp__filters">
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">CNPJ</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="cnpj"
                                        placeholder="CNPJ"
                                        value={dados.cnpj || ''}
                                        onChange={e => setDados({ ...dados, ...{ "cnpj": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">CPF</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="cpf"
                                        placeholder="CPF"
                                        value={dados.cpf || ''}
                                        onChange={e => setDados({ ...dados, ...{ "cpf": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Inscrição Estadual</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="inscricaoestadual"
                                        placeholder="Inscrição Estadual"
                                        value={dados.inscricaoestadual || ''}
                                        onChange={e => setDados({ ...dados, ...{ "inscricaoestadual": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Indicador de Inscrição</label>
                                    <ReactSelect
                                        value={{ value: dados.indicadorinscricao, label: dados.nomeIndicadorinscricao }}
                                        onChange={e => setDados({ ...dados, ...{ "indicadorinscricao": e.value, "nomeIndicadorinscricao": e.label } })}
                                        options={OPTS_INDICADORINSCRICAO}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Inscrição Municipal</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="inscricaomunicipal"
                                        placeholder="Inscrição Municipal"
                                        value={dados.inscricaomunicipal || ''}
                                        onChange={e => setDados({ ...dados, ...{ "inscricaomunicipal": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Regime Tributário</label>
                                    <ReactSelect
                                        value={{ value: dados.regimetributario, label: dados.nomeRegimetributario }}
                                        onChange={e => setDados({ ...dados, ...{ "regimetributario": e.value, "nomeRegimetributario": e.label } })}
                                        options={OPTS_REGIMETRIBUTARIO}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">RG</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="rg"
                                        placeholder="RG"
                                        value={dados.rg || ''}
                                        onChange={e => setDados({ ...dados, ...{ "rg": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Nome Fantasia</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="nomefantasia"
                                        placeholder="Nome Fantasia"
                                        value={dados.nomefantasia || ''}
                                        onChange={e => setDados({ ...dados, ...{ "nomefantasia": e.target.value } })}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Seção: Banco */}
                        <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                            <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                                <h2 className="fin-pp__cphead-title">Banco</h2>
                            </div>
                            <div className="fin-pp__filters">
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Banco</label>
                                    <ReactSelect
                                        value={{ value: dados.banco, label: dados.nomeBanco }}
                                        onChange={e => setDados({ ...dados, ...{ "banco": e.value, "nomeBanco": e.label } })}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/financeiroBanco',
                                                token: token,
                                                params: { nome: input }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map(registro => ({ value: registro.id, label: registro.codigo + " - " + registro.nome }));
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Agência</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="bancoagencia"
                                        placeholder="Agência"
                                        value={dados.bancoagencia || ''}
                                        onChange={e => setDados({ ...dados, ...{ "bancoagencia": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Dígito (agência)</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="bancoagenciadigito"
                                        placeholder="Dígito"
                                        value={dados.bancoagenciadigito || ''}
                                        onChange={e => setDados({ ...dados, ...{ "bancoagenciadigito": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Conta</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="bancoconta"
                                        placeholder="Conta"
                                        value={dados.bancoconta || ''}
                                        onChange={e => setDados({ ...dados, ...{ "bancoconta": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Dígito (conta)</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="bancocontadigito"
                                        placeholder="Dígito"
                                        value={dados.bancocontadigito || ''}
                                        onChange={e => setDados({ ...dados, ...{ "bancocontadigito": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">PIX</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="pix"
                                        placeholder="PIX"
                                        value={dados.pix || ''}
                                        onChange={e => setDados({ ...dados, ...{ "pix": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Valor Transporte Dia (R$)</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="valortransportedia"
                                        placeholder="Valor Transporte Dia (R$)"
                                        value={dados.valortransportedia || ''}
                                        onChange={e => setDados({ ...dados, ...{ "valortransportedia": e.target.value } })}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Seção: Contato de Emergência */}
                        <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                            <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                                <h2 className="fin-pp__cphead-title">Contato de Emergência</h2>
                            </div>
                            <div className="fin-pp__filters">
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Nome contato para emergência</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="contatoemergencianome"
                                        placeholder="Nome contato para emergência"
                                        value={dados.contatoemergencianome || ''}
                                        onChange={e => setDados({ ...dados, ...{ "contatoemergencianome": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Telefone emergência</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="contatoemergenciatelefone"
                                        placeholder="Telefone emergência"
                                        value={dados.contatoemergenciatelefone || ''}
                                        onChange={e => setDados({ ...dados, ...{ "contatoemergenciatelefone": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Grau de Parentesco</label>
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="contatoemergenciaparentesco"
                                        placeholder="Grau de Parentesco"
                                        value={dados.contatoemergenciaparentesco || ''}
                                        onChange={e => setDados({ ...dados, ...{ "contatoemergenciaparentesco": e.target.value } })}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Seção: Acesso */}
                        <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                            <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                                <h2 className="fin-pp__cphead-title">Acesso</h2>
                            </div>
                            <div className="fin-pp__filters">
                                <div className="fin-pp__field" style={{ flexBasis: '48%' }}>
                                    <label className="fin-pp__label">Cliente</label>
                                    <ReactSelect
                                        isMulti={true}
                                        id="cliente"
                                        value={dados.cliente}
                                        onChange={(e) => {
                                            dados.cliente = dados.cliente || [];
                                            dados.cliente = e;
                                            setDados({ ...dados });
                                        }}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/participante',
                                                token: token,
                                                params: {
                                                    nome: input,
                                                    tipoCadastro: "cliente",
                                                    situacaoRegistro: "ativo",
                                                }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map((registro) => {
                                                        var label = registro.codigo +
                                                            ' - ' + registro.nome +
                                                            (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                            (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                            (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                            (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                        return {
                                                            value: registro.id,
                                                            label: label
                                                        };
                                                    });
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </div>
                                <div className="fin-pp__field" style={{ flexBasis: '48%' }}>
                                    <label className="fin-pp__label">Eventos</label>
                                    <ReactSelect
                                        isMulti={true}
                                        value={dados.eventos}
                                        onChange={(e) => {
                                            dados.eventos = dados.eventos || [];
                                            dados.eventos = e;
                                            setDados({ ...dados });
                                        }}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/evento',
                                                token: token,
                                                params: {
                                                    nome: input,
                                                    cliente: (dados.cliente && Array.isArray(dados.cliente)) ? dados.cliente.map(item => item.value).join(',') : null,
                                                    situacao: ["ativo", "fechado"]
                                                }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map((registro) => {
                                                        var label = registro.nome;
                                                        if (registro.identificacao) {
                                                            label = registro.identificacao + " - " + label;
                                                        }
                                                        if (registro.cliente) {
                                                            label = label + ' - ' + registro.cliente.nome;
                                                        }
                                                        label = registro.codigo + " - " + label;
                                                        return { value: registro.id, label: label };
                                                    });
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </div>
                                <div className="fin-pp__field" style={{ flexBasis: '48%' }}>
                                    <label className="fin-pp__label">Unidade de Negócios</label>
                                    <ReactSelect
                                        isMulti={true}
                                        value={dados.unidadenegocio ?? []}
                                        onChange={(e) => {
                                            dados.unidadenegocio = dados.unidadenegocio || [];
                                            dados.unidadenegocio = e;
                                            setDados({ ...dados });
                                        }}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/produtoUnidadeNegocio',
                                                token: token,
                                                params: { nome: input }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">BU</label>
                                    <ReactSelect
                                        isMulti={true}
                                        value={dados.bu ?? []}
                                        onChange={(e) => {
                                            dados.bu = dados.bu || [];
                                            dados.bu = e;
                                            setDados({ ...dados });
                                        }}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/produtoBu',
                                                token: token,
                                                params: { nome: input }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map(registro => ({ value: registro.id, label: registro.codigo + " - " + registro.nome }));
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Nacionalidade do Evento</label>
                                    <ReactSelect
                                        value={{ value: dados.nacionalidadeEvento, label: dados.nomeNacionalidadeEvento }}
                                        onChange={e => setDados({ ...dados, ...{ "nacionalidadeEvento": e.value, "nomeNacionalidadeEvento": e.label } })}
                                        options={OPTS_NACIONALIDADE_EVENTO}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Usuário</label>
                                    <input
                                        type="email"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="email"
                                        placeholder="Usuário"
                                        value={dados.email || ''}
                                        onChange={e => setDados({ ...dados, ...{ "email": e.target.value } })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Senha</label>
                                    <input
                                        type="password"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        id="senha"
                                        placeholder="Senha"
                                        value={dados.senha || ''}
                                        onChange={e => setDados({ ...dados, ...{ "senha": e.target.value } })}
                                    />
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting
                                ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</>
                                : <><FaSave size={16} /> Salvar</>
                            }
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
